<template>
    <div class="table-auto overflow-scroll w-full">
        <div v-if="loading" class="flex justify-center items-center flex-col">
            <sirit-icon model="refresh-cw" rotate />
            <span class="mt-2">Cargando...</span>
        </div>

        <table v-else class="border-collapse sirit-table w-full ">
            <tr v-if="headers.length > 0">
                <th v-for="(header, key) in headers" v-bind:key="key"
                    class=" font-semibold text-lg"
                    :class="[
                        header.align === 'left' ? 'text-left' : '',
                        header.align === 'center' ? 'text-center' : '',
                        header.align === 'right' ? 'text-right' : '',
                ]">
                    {{ header.label }}
                </th>
            </tr>
            <tbody>
                <tr v-for="(row, index) in items" v-bind:key="index"
                    class="text-md" :class="`hover:bg-${colors.primary}-50`">
                    <slot :item="row">
                        <td v-for="(value, key) in row" v-bind:key="key"></td>
                    </slot>
                </tr>
            </tbody>
        </table>

        <div v-if="!loading && pagination"
             class="flex justify-end items-center">
            <sirit-icon v-if="loadingPage" model="refresh-cw" class="mr-2" rotate />
            <sirit-button-icon @onClick="getPreviousPage" icon="chevron-left" color="clean"
                               :disabled="disablePreviousPage" />
            <span class="text-md ml-2 mr-2">
                Página actual: {{actualPage}}, Total: {{maxPages}}
            </span>
            <sirit-button-icon @onClick="getNextPage" icon="chevron-right" color="clean"
                               :disabled="disableNextPage" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs, watch } from 'vue'
import SiritIcon from '@/components/Commons/SiritIcon.vue'
//import SiritButton from '@/components/Commons/SiritButton.vue'
import SiritButtonIcon from '@/components/Commons/SiritButtonIcon.vue'
import {state}  from '@/api/global'

export default defineComponent({
    name: "SiritTable",
    components: {
        SiritIcon, SiritButtonIcon
    },
    props: {
        headers: { type: Array, required: false },
        items: { type: Array, required: true },
        loading: { type: Boolean, required: false, default: false },
        loadingPage: { type: Boolean, required: false, default: false },
        pagination: { type: Boolean, required: false, default: false },
        page: { type: Number, required: false, default: 0 },
        itemsPerPage: { type: Number, required: false, default: 30 },
        maxPages: { type: Number, required: false, default: 0 }
    },
    emits: [
        'getNextPage', 'getPreviousPage'
    ],
    setup (props, { emit }) {

        const { colors } = state.configTenant.template;

        interface siritTable {
            actualPage: number,
            disablePreviousPage: boolean,
            disableNextPage: boolean
        }

        const data = reactive<siritTable>({
            actualPage: props.page + 1,
            disablePreviousPage: false,
            disableNextPage: false
        })

        function getNextPage () { emit('getNextPage') }

        function getPreviousPage () { emit('getPreviousPage') }

        function isDisableNextPage () { 
            if (data.actualPage === props.maxPages){ 
                data.disableNextPage = true 
            } 
        }

        watch(() => props.page, (newPage) => {
            data.actualPage = newPage + 1
            data.disablePreviousPage = data.actualPage === 1
            data.disableNextPage = props.maxPages === newPage + 1;
        })

        watch(() => props.items, () => {
            isDisableNextPage();
        })

        if (data.actualPage === 1) { data.disablePreviousPage = true }

        isDisableNextPage();

        return {
            colors,
            ...toRefs(data),
            getNextPage,
            getPreviousPage,
            isDisableNextPage
        }
    }
})
</script>
